import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRestore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M28.4 38H14V35H28.45Q31.95 35 34.475 32.675Q37 30.35 37 26.9Q37 23.45 34.475 21.125Q31.95 18.8 28.45 18.8H13.7L19.4 24.5L17.3 26.6L8 17.3L17.3 8L19.4 10.1L13.7 15.8H28.4Q33.15 15.8 36.575 19Q40 22.2 40 26.9Q40 31.6 36.575 34.8Q33.15 38 28.4 38Z" })
});
export default SvgRestore;
